import { useEffect, useMemo, useState } from "react";
import { useSelector } from "react-redux";
import API from "../api";
import { selectUser } from "../store/authSlice";
import "./css/user-profile.css";

const empty = {
  id: null,
  username: "",
  email: "",
  mobile: "",
  role: "",
  ass: "",
  status: "",
  photo_url: "",
  address: "",
  city: "",
  state: "",
  zip: "",
  country: "",
};

export default function UserProfile() {
  const reduxUser = useSelector(selectUser);
  const myId = reduxUser?.id;
  const myRole = useMemo(() => String(reduxUser?.role || "").toLowerCase(), [reduxUser]);
  const myAss = reduxUser?.ass ?? "—";

  const [form, setForm] = useState(empty);
  const [loading, setLoading] = useState(true);
  const [saving, setSaving] = useState(false);
  const [error, setError] = useState("");
  const [msg, setMsg] = useState("");

  const [pwd, setPwd] = useState("");
  const [pwd2, setPwd2] = useState("");

  const load = async () => {
    try {
      setLoading(true);
      setError("");
      const resp = await API.get("/auth/profile", {
        params: { id: myId, role: myRole },
      });
      const data = resp?.data || {};
      setForm({
        ...empty,
        ...data,
      });
    } catch (e) {
      console.error(e);
      setError("Could not load profile.");
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    if (!myId) return;
    load();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [myId, myRole]);

  const onChange = (k, v) => setForm((p) => ({ ...p, [k]: v }));

  const onSubmit = async (e) => {
    e.preventDefault();
    setMsg("");
    setError("");

    // client-side password validation
    if (pwd || pwd2) {
      if (!pwd || !pwd2) {
        setError("Password and confirm password are required.");
        return;
      }
      if (pwd !== pwd2) {
        setError("Passwords do not match.");
        return;
      }
      if (pwd.length < 6) {
        setError("Password must be at least 6 characters.");
        return;
      }
    }

    try {
      setSaving(true);
      const payload = {
        id: form.id || myId,
        role: myRole,
        username: form.username,
        email: form.email,
        mobile: form.mobile,
        // address: form.address,
        // city: form.city,
        // state: form.state,
        // zip: form.zip,
        // country: form.country,
        status: form.status,
        photo_url: form.photo_url,
        password: pwd || undefined,
        confirmPassword: pwd2 || undefined,
      };
      const resp = await API.put("/auth/profile", payload);
      const updated = resp?.data?.user || form;
      setForm(updated);
      setPwd("");
      setPwd2("");
      setMsg("Profile updated.");
    } catch (e) {
      console.error(e);
      setError(e?.response?.data?.error || "Update failed.");
    } finally {
      setSaving(false);
    }
  };

  return (
    <div className="up-wrap">
      <div className="up-header">
        <h2 className="up-h2">User Profile</h2>
        <div className="up-sub">
          {reduxUser?.username} &nbsp;•&nbsp; {myRole || "user"} &nbsp;•&nbsp; ASS {myAss ?? "—"}
        </div>
      </div>

      {loading && <div className="up-empty">Loading…</div>}
      {error && <div className="up-error">{error}</div>}
      {msg && <div className="up-success">{msg}</div>}

      {!loading && !error && (
        <div className="up-grid">
          {/* LEFT: avatar card */}
          <div className="up-card up-left">
            <div className="up-avatar">
              {form.photo_url ? (
                <img src={form.photo_url} alt={form.username || "User"} />
              ) : (
                <div className="up-avatar-fallback">
                  {(form.username || "U")
                    .split(/\s+/)
                    .slice(0, 2)
                    .map((s) => s[0]?.toUpperCase())
                    .join("") || "U"}
                </div>
              )}
            </div>
            <div className="up-left-name">{form.username || "Unnamed"}</div>
            <div className="up-left-meta">{form.email || "—"}</div>
            <div className="up-left-meta">Role: {form.role || myRole}</div>
            <div className="up-left-meta">ASS: {form.ass ?? myAss}</div>
            <div className="up-left-row">
              <label>Photo URL</label>
              <input
                type="url"
                value={form.photo_url || ""}
                onChange={(e) => onChange("photo_url", e.target.value)}
                placeholder="https://…"
              />
            </div>
          </div>

          {/* RIGHT: details form */}
          <form className="up-card up-right" onSubmit={onSubmit}>
            <div className="up-form-grid">
              <div className="up-field">
                <label> Name</label>
                <input
                  type="text"
                  value={form.username || ""}
                  onChange={(e) => onChange("username", e.target.value)}
                  disabled
                />
              </div>

              <div className="up-field">
                <label>Email</label>
                <input
                  type="email"
                  value={form.email || ""}
                  onChange={(e) => onChange("email", e.target.value)}
                  disabled
                />
              </div>

              <div className="up-field">
                <label>Phone</label>
                <input
                  type="tel"
                  value={form.mobile || ""}
                  onChange={(e) => onChange("mobile", e.target.value)}
                />
              </div>

              <div className="up-field">
                <label>Status</label>
                <input
                  type="text"
                  value={form.status || ""}
                  onChange={(e) => onChange("status", e.target.value)}
                />
              </div>

              <div className="up-field">
                <label>Role</label>
                <input type="text" value={form.role || myRole} disabled />
              </div>

              <div className="up-field">
                <label>ASS</label>
                <input type="text" value={form.ass ?? myAss} disabled />
              </div>

              <div className="up-sep">Address</div>

              <div className="up-field">
                <label>Street</label>
                <input
                  type="text"
                  value={form.address || ""}
                  onChange={(e) => onChange("address", e.target.value)}
                />
              </div>

              <div className="up-field">
                <label>City</label>
                <input
                  type="text"
                  value={form.city || ""}
                  onChange={(e) => onChange("city", e.target.value)}
                />
              </div>

              <div className="up-field">
                <label>State</label>
                <input
                  type="text"
                  value={form.state || ""}
                  onChange={(e) => onChange("state", e.target.value)}
                />
              </div>

              <div className="up-field">
                <label>ZIP</label>
                <input
                  type="text"
                  value={form.zip || ""}
                  onChange={(e) => onChange("zip", e.target.value)}
                />
              </div>

              <div className="up-field">
                <label>Country</label>
                <input
                  type="text"
                  value={form.country || ""}
                  onChange={(e) => onChange("country", e.target.value)}
                />
              </div>

              <div className="up-sep">Change Password</div>

              <div className="up-field">
                <label>New Password</label>
                <input
                  type="password"
                  value={pwd}
                  onChange={(e) => setPwd(e.target.value)}
                  placeholder="Leave blank to keep"
                />
              </div>

              <div className="up-field">
                <label>Confirm Password</label>
                <input
                  type="password"
                  value={pwd2}
                  onChange={(e) => setPwd2(e.target.value)}
                  placeholder="Re-enter password"
                />
              </div>
            </div>

            <div className="up-actions">
              <button className="up-btn up-btn-primary" disabled={saving}>
                {saving ? "Saving…" : "Save Changes"}
              </button>
              <button
                className="up-btn"
                type="button"
                onClick={load}
                disabled={saving}
                title="Reload from server"
              >
                Reset
              </button>
            </div>
          </form>
        </div>
      )}
    </div>
  );
}
